import { IStyle } from "@fluentui/react";

export const CommonStyle:IStyle = {
    borderBottomStyle: 'solid',
    position: 'relative',
    borderBottomWidth: '1px',
    borderBottomColor: 'rgb(243, 242, 241)'
};